import React from 'react';

export default function HeroCard() {
  return (
    <header
      className="rounded-2xl p-8 md:p-12 text-center mb-6 shadow-md"
      style={{ backgroundColor: 'var(--card)' }}
    >
      <p
        className="text-sm font-semibold tracking-widest uppercase mb-4"
        style={{ color: 'var(--primary)' }}
      >
        #Vimi
      </p>

      <h1
        className="font-display text-4xl md:text-5xl font-medium mb-2"
        style={{ color: 'var(--foreground)' }}
      >
        Vikas &amp; Anamika
      </h1>

      <p
        className="font-display text-xl md:text-2xl mb-5"
        style={{ color: 'var(--secondary)' }}
      >
        We&apos;re getting married!
      </p>

      <p
        className="max-w-lg mx-auto text-base leading-relaxed mb-8"
        style={{ color: 'var(--muted-foreground)' }}
      >
        We&apos;d love to celebrate these special days with you. Since many of
        you may be travelling from different cities, we&apos;d also like to
        understand your travel and accommodation requirements so we can plan
        everything comfortably.
      </p>

      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <div
          className="flex-1 rounded-xl p-5 text-left"
          style={{ backgroundColor: 'var(--background)' }}
        >
          <p className="font-display text-lg font-semibold mb-2">
            💍 Engagement
          </p>
          <p className="text-sm leading-relaxed" style={{ color: 'var(--foreground)' }}>
            31 December 2026
          </p>
          <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>
            12:00 PM – 5:00 PM
          </p>
          <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>
            Bhopal, Madhya Pradesh
          </p>
          <a
            href="https://maps.app.goo.gl/o6Wyuiqrn5Wi5iZo7"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-3 text-sm font-medium transition-colors hover:underline"
            style={{ color: 'var(--primary)' }}
          >
            View Location →
          </a>
        </div>

        <div
          className="flex-1 rounded-xl p-5 text-left"
          style={{ backgroundColor: 'var(--background)' }}
        >
          <p className="font-display text-lg font-semibold mb-2">
            ❤️ Wedding
          </p>
          <p className="text-sm leading-relaxed" style={{ color: 'var(--foreground)' }}>
            4 January 2027
          </p>
          <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>
            Early Morning – ~3:00 PM
          </p>
          <p className="text-sm" style={{ color: 'var(--muted-foreground)' }}>
            Warud, Maharashtra
          </p>
          <a
            href="https://share.google/GkJH2GKIEW7xkHvDR"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-3 text-sm font-medium transition-colors hover:underline"
            style={{ color: 'var(--primary)' }}
          >
            View Location →
          </a>
        </div>
      </div>
    </header>
  );
}